/* eslint-disable camelcase */
export const warrantyActivationInitiatedClicked = (country, warranty_entry_point, product_type, channel) => {
  if (process.env.NEXT_PUBLIC_SEGMENT_ID) {
    window.analytics.track('Warranty Activation Initiated Clicked', {
      warranty_entry_point,
      product_type,
      channel
    },
    {
      context: {
        location: {
          country
        }
      }
    });
  }
};
export const warrantyActivationHelpClicked = (country, topic) => {
  if (process.env.NEXT_PUBLIC_SEGMENT_ID) {
    window.analytics.track('Warranty Activation Help Clicked', {
      topic
    },
    {
      context: {
        location: {
          country
        }
      }
    });
  }
};
export const warrantyActivationFailed = (country, error_type, serial_no) => {
  if (process.env.NEXT_PUBLIC_SEGMENT_ID) {
    window.analytics.track('Warranty Activation Failed', {
      error_type, serial_no
    },
    {
      context: {
        location: {
          country
        }
      }
    });
  }
};
export const warrantyActivationSuccess = (country, product_type) => {
  if (process.env.NEXT_PUBLIC_SEGMENT_ID) {
    window.analytics.track('Warranty Activated Success Viewed', {
      product_type
    },
    {
      context: {
        location: {
          country
        }
      }
    });
  }
};
export const warrantyDeviceDetails = (country, product_type) => {
  if (process.env.NEXT_PUBLIC_SEGMENT_ID) {
    window.analytics.track('Warranty Device Details', {
      product_type
    },
    {
      context: {
        location: {
          country
        }
      }
    });
  }
};
export const shopSimilarProductsClicked = (country, topic) => {
  if (process.env.NEXT_PUBLIC_SEGMENT_ID) {
    window.analytics.track('Shop Similar Products Clicked', {
      topic
    },
    {
      context: {
        location: {
          country
        }
      }
    });
  }
};
export const warrantyCardMisplacedClicked = (country) => {
  if (process.env.NEXT_PUBLIC_SEGMENT_ID) {
    window.analytics.track('Warranty Card Misplaced Clicked',
      {
        context: {
          location: {
            country
          }
        }
      });
  }
};
export const warrantyFormSubmitted = (country, event, product_type, order_id_blank) => {
  if (process.env.NEXT_PUBLIC_SEGMENT_ID) {
    window.analytics.track(event,
      { product_type, order_id_blank },
      {
        context: {
          location: {
            country
          }
        }
      });
  }
};
export const warrantyFormError = (country, event, product_type, invalid_fields) => {
  if (process.env.NEXT_PUBLIC_SEGMENT_ID) {
    window.analytics.track(event,
      { product_type, invalid_fields },
      {
        context: {
          location: {
            country
          }
        }
      });
  }
};
export const warrantyFormSubmitSuccess = (country, topic, product_type) => {
  if (process.env.NEXT_PUBLIC_SEGMENT_ID) {
    window.analytics.track(topic,
      { product_type },
      {
        context: {
          location: {
            country
          }
        }
      });
  }
};
